import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {Injectable} from '@angular/core';
import {catchError} from 'rxjs/operators';

@Injectable()
export class RetryInterceptor implements HttpInterceptor {
    private readonly MAX_RETRIES = 2;
    private readonly TIMEOUT_HTTP_STATUS_CODE = 408;
    private readonly CONFLICT_HTTP_STATUS_CODE = 409;
    private readonly ISOLATION_LEVEL_HEADER = 'issnapshotisolationlevel';

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let retries = 0;

        const errorHandler = catchError((error: Observable<HttpErrorResponse>) => {
            if (retries < this.MAX_RETRIES &&
                error instanceof HttpErrorResponse &&
                (error.status === this.CONFLICT_HTTP_STATUS_CODE || error.status === this.TIMEOUT_HTTP_STATUS_CODE)) {
                const newReq = req.clone({headers: req.headers.set(this.ISOLATION_LEVEL_HEADER, 'true')});
                retries++;
                return next.handle(newReq).pipe(errorHandler);
            } else {
                return throwError(() => error);
            }
        });

        return next.handle(req).pipe(errorHandler);
    }
}